import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import API, { action } from "../../Api";
import moment from "moment/moment";
import { IoMdClose } from "react-icons/io";

function CattleTypeHistory({
  isOpen,
  toggle,
  selectedItem,
  setSeelctedCattleId,
}) {
  const [historyData, setHistoryData] = useState(null);

  useEffect(() => {
    getTypeHistoryData();
  }, [selectedItem]);

  const getTypeHistoryData = async () => {
    try {
      const result = await action(API.GET_TYPE_HISTORY, {
        id: selectedItem,
      });

      setHistoryData(result.response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnclose = () => {
    toggle();
    setSeelctedCattleId(null);
    setHistoryData(null);
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={handleOnclose}
        className="modal-dialog-centered modal-md"
      >
        <button
          type="button"
          onClick={handleOnclose}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            zIndex: 1001,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <IoMdClose size={18} color="#333" />
        </button>
        <div className="p-[40px]">
          <div>
            <div className="text-[18px] font-semibold 2xl:text-2xl text-[#09090B] font-plus-jakarta-sans">
              Cattle Type History
            </div>
            <div className="text-[12px] 2xl:text-sm text-[#726C6C] font-plus-jakarta-sans">
            View the cattle type change history from here.
            </div>
          </div>
        </div>
        <div className="text-center">
          <h1 className="text-[18px] font-semibold ">
            Cattle ID : {historyData?.cattle_id}
          </h1>
        </div>
        <ModalBody>
          <div className="overflow-x-auto h-75">
            <table className="bg-white border border-gray-200 w-full">
              <thead>
                <tr className="bg-gray-100 text-left">
                  <th className="px-4 py-2 border-b text-md whitespace-nowrap">
                    Sl.No
                  </th>
                  <th className="px-4 py-2 border-b text-md whitespace-nowrap">
                    Type
                  </th>
                  <th className="px-4 py-2 border-b text-md whitespace-nowrap">
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {historyData &&
                  historyData?.type_history?.map((cattle, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-2 border-b whitespace-nowrap">
                        {index + 1}
                      </td>
                      <td className="px-4 py-2 border-b whitespace-nowrap">
                        {cattle?.CattleType?.cattle_type_name}
                      </td>
                      <td className="px-4 py-2 border-b whitespace-nowrap">
                        {moment(cattle?.added_on).format("DD-MM-YYYY")}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default CattleTypeHistory;
